import { createApiSlice } from 'app/createApiSlice'
import { API_EVENT_PARTNER } from 'utils/apiList'

export const eventPartnerApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'event-partner/hooks',
  endpoints(builder) {
    return {
      fetchEventPartner: builder.query({
        query(params) {
          return {
            url: API_EVENT_PARTNER,
            params,
          }
        },
      }),
      fetchEventPartnerForForm: builder.query({
        query() {
          return `${API_EVENT_PARTNER}?all=true`
        },
        transformResponse(response) {
          return response?.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        },
      }),
      addEventPartner: builder.mutation({
        query(payload) {
          return {
            url: API_EVENT_PARTNER,
            method: 'POST',
            body: payload,
          }
        },
      }),
      editEventPartner: builder.mutation({
        query(payload) {
          return {
            url: `${API_EVENT_PARTNER}/${payload.id}`,
            method: 'PUT',
            body: payload,
          }
        },
      }),
      deleteEventPartner: builder.mutation({
        query(payload) {
          return {
            url: API_EVENT_PARTNER,
            method: 'DELETE',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchEventPartnerQuery,
  useFetchEventPartnerForFormQuery,
  useAddEventPartnerMutation,
  useEditEventPartnerMutation,
  useDeleteEventPartnerMutation,
} = eventPartnerApiSlice
